module.exports = __webpack_public_path__ + "img/now-and-then.53f3a797.png";